import NbComponentsPlugin, { Directives } from "@nationbetter/nb-components";

import "@nationbetter/nb-components/dist/nb-components.css";
import "@nationbetter/nb-components/src/packages";
import "@nationbetter/nb-components/src/styles/app.sass";
import "@nationbetter/nb-components/src/styles/_variables.css";
import Vue from "vue";

Vue.use(NbComponentsPlugin);
Vue.use(Directives);
